export function emphLearn() {
    const navLinkLearn = document.querySelector('#nav-link-learn')
    if (!navLinkLearn) return
    navLinkLearn.classList.add('emph-learn')
    setTimeout(() => navLinkLearn.classList.remove('emph-learn'), 1000)
}